<template>
  <div class="login">
    <div class="content">
      <div class="logo">
        <img src="static/img/logo1.png">
        <p>淘金区域代理</p>
      </div>
      <div class="txt">
        <div class="all account">
          <span>账号：</span>
          <input type="text" v-model="account" placeholder="请输入账号">
        </div>
        <div class="all password">
          <span>密码：</span>
          <input type="password" autocomplete="new-password" v-model="password" placeholder="请输入密码">
        </div>
        <button type="button" @click="login">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      'account': '',
      'password': ''
    }
  },
  mounted() {
    this.getCookie()
  },
  methods: {
    login: function() {
      if(this.account == '') {
        this.$message({
          message: '请输入账号',
          type: 'error',
          center: true,
          duration: 2000
        })
        return
      }
       if(this.password == '') {
        this.$message({
          message: '请输入密码',
          type: 'error',
          center: true,
          duration: 2000
        })
        return
      }
      var data = {
        'phoneNumber': this.account,
        'password': this.password
      }
      this.$http.post(API_ROOT.system + "/agency/login",data).then(response=> {
        var result = response.data
        if(result.success) {
          var self = this
          this.$message({
						message: "登录成功",
						type: 'success',
						center: true,
						duration: 1000
          })
          this.setCookie(this.account,this.password,7);
          var exdate=new Date()
          exdate.setTime(exdate.getTime() + 24*60*60*1000*7)//保存的天数
          window.document.cookie = "reginal_agency_token"+"="+result.data.reginal_agency_token+";path=/;expires="+exdate.toGMTString()
          setTimeout(function() {
            self.$router.push({name: 'runnability'});
          },1000)
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          })
        }
      },response=> {
        this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        })
      })
    },
    setCookie(c_name,c_pwd,exdays) {
      var exdate=new Date()
      exdate.setTime(exdate.getTime() + 24*60*60*1000*exdays)//保存的天数
      //字符串拼接cookie
      window.document.cookie="userName"+ "=" +c_name+";path=/;expires="+exdate.toGMTString();
      window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
    },
    getCookie:function () {
      if (document.cookie.length>0) {
        var arr=document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
        for(var i=0;i<arr.length;i++){
          var arr2=arr[i].split('=');//再次切割
          //判断查找相对应的值
          if(arr2[0]=='userName'){
            this.account=arr2[1];//保存到保存数据的地方
          }else if(arr2[0]=='userPwd'){
            this.password=arr2[1];
          }
        }
      }
    },
  }
}
</script>




// WEBPACK FOOTER //
// login.vue?467e1d2d